import { render, staticRenderFns } from "./controller-group.vue?vue&type=template&id=a8d8981c"
import script from "./controller-group.vue?vue&type=script&lang=js"
export * from "./controller-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports